import { Box, Flex, Text } from "@chakra-ui/react";
import Lottie from "lottie-react";
import LoaderBg from "@root/assets/images/custom-loader-bg.svg";
// 👇 import the JSON animation
import loading from "@root/assets/animations/loading.json"

const SingleLoader = ({ text = "loading...", progress = 0 }) => {
  return (
    <Flex height="100%" justifyContent="center" alignItems="center">
      <Flex
        bgImage={LoaderBg}
        width="500px"
        height="450px"
        justifyContent="center"
        alignItems="center"
        bgSize="cover"
        position="relative"
      >
        {/* Lottie Animation */}
        <Box marginTop="50px">
          <Lottie 
            animationData={loading} 
            loop={true} 
            style={{ width: 200, height: 200 }} 
          />
        </Box>

        {/* Percentage in center */}
        <Flex
          position="absolute"
          top="55%"
          left="50%"
          transform="translate(-50%, -50%)"
          justify="center"
          align="center"
          flexDir="column"
        >
          <Text fontSize="20px" fontWeight="bold" color="#000000">
            {progress}%
          </Text>
        </Flex>

        {/* Bottom text */}
        <Box position="absolute" bottom="30px" width="100%">
          <Text fontSize="14px" color="#231F20" textAlign="center">
            {text}
          </Text>
        </Box>
      </Flex>
    </Flex>
  );
};

export default SingleLoader;
